/*
    Define  font families under generic names
    to allow for easier branding updates
*/

const linotype = {
  normal: 'Linotype-Pro-Reg',
  medium: 'Linotype-Pro-Medium',
};

const carbon = {
  bold: 'Carbon-Bold',
};

export const FONTS = {
  default: linotype.normal,
  special: carbon.bold,
  emphasized: linotype.medium,
};
